<template>
  <div class="voucher-code">
    <div class="form-group">
      <input
        id="voucher"
        class="input-text__underline voucher-code__input"
        :class="{'is-invalid': voucherError, 'is-valid': value,}"
        name="voucher"
        type="text"
        :placeholder="trans.get('ms:shop.enter_voucher_code')"
        v-model="voucher"
      >
      <div class="voucher__info" v-if="value && value.type === gType.percent">
        {{ trans.get('ms:shop.bonus') }} +{{ value.discount }}%
      </div>
      <div class="voucher__info" v-if="value && value.type === gType.quantity">
        {{ trans.get('ms:shop.bonus') }} +{{ value.discount }}
      </div>
      <div v-if="voucherError" class="invalid-feedback">{{ trans.get('ms:shop.wrong_voucher_code') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Voucher',
  components: {},
  props: {
    value: Object | null,
    unit: String,
  },
  data() {
    return {
      voucher: null,
      voucherError: false,
      gType: {
        percent: window.globals.voucher.type_percent,
        quantity: window.globals.voucher.type_quantity,
      }
    };
  },
  computed: {},
  watch: {
    voucher() {
      this.fetchVoucherData();
    },
  },
  methods: {
    emitVoucherData: function (voucher) {
      this.$emit('input', voucher);
    },
    fetchVoucherData: _.debounce(function () {
      this.voucherError = false;
      axios.get(zRoute('ajax.voucher.search', {
        voucher: this.voucher,
        unit: this.unit,
      })).then((response) => {
        this.emitVoucherData(response.data.data);
      }).catch((response) => {
        this.voucherError = true;
        this.emitVoucherData(null);
      });
    }, 500),
  },
  mounted() {
  }
};
</script>
